(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/statistics/big/views/big-main_desktop.js') >= 0) return;  svs.modules.push('/components/statistics/big/views/big-main_desktop.js'); (function(svs, Handlebars) {
_svs=window.svs=window.svs||{};
_svs.statistics=_svs.statistics||{};
_svs.statistics.big=_svs.statistics.big||{};
_svs.statistics.big.templates=_svs.statistics.big.templates||{};
svs.statistics.big.templates.big_main = Handlebars.template({"compiler":[7,">= 4.0.0"],"main":function(container,depth0,helpers,partials,data) {
    return "<div class=\"js-big-header big-header relative\">\n\n</div>\n<div class=\"js-big-content big-content\">\n\n</div>";
},"useData":true});
Handlebars.partials['components-statistics-big-big_main'] = svs.statistics.big.templates.big_main;
})(svs, Handlebars);

 })(window);